<template>
  <div>
    <DeletedMessageBalloon v-if="isDeletedMessage" :message="message" :index="index" />

    <div v-else>
      <TextMessageBalloon v-if="dem.MessageType === 0" :message="dem" :index="index" />
      <ImageMessageBalloon v-else-if="dem.MessageType === 1" :message="dem" :index="index" />
      <VideoMessageBalloon v-else-if="dem.MessageType === 2" :message="dem" :index="index" />
      <LocationMessageBalloon v-else-if="dem.MessageType == 4" :message="dem" :index="index" />
      <ContactMessageBalloon v-else-if="dem.MessageType === 6" :message="dem" :index="index" />
      <InfoMessageBalloon v-else-if="dem.MessageType === 7" :message="dem" :index="index" />
      <UnansweredCallBalloon v-else-if="dem.MessageType === 20" :message="dem" :index="index" />
      <AuidoMessageBalloon v-else-if="dem.MessageType === 8" :message="dem" :index="index" />
      <DateMessageBalloon v-else-if="dem.MessageType === 99" :message="dem" :index="index" />
      <DocumentMessageBalloon v-else-if="dem.MessageType === 100" :message="dem" :index="index" />
      <div class="unknownType" v-else>
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import DeletedMessageBalloon from './messageTypes/DeletedMessageBalloon.vue'
import TextMessageBalloon from './messageTypes/TextMessageBalloon.vue'
import ImageMessageBalloon from './messageTypes/ImageMessageBalloon.vue'
import VideoMessageBalloon from './messageTypes/VideoMessageBalloon.vue'
import LocationMessageBalloon from './messageTypes/LocationMessageBalloon.vue'
import ContactMessageBalloon from './messageTypes/ContactMessageBalloon.vue'
import InfoMessageBalloon from './messageTypes/InfoMessageBalloon.vue'
import AuidoMessageBalloon from './messageTypes/AuidoMessageBalloon.vue'
import DateMessageBalloon from './messageTypes/DateMessageBalloon.vue'
import DocumentMessageBalloon from './messageTypes/DocumentMessageBalloon.vue'
import UnansweredCallBalloon from './messageTypes/UnansweredCallBalloon.vue'
require('@/security.js')

var moment = require('moment')

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: {
    DeletedMessageBalloon,
    TextMessageBalloon,
    ImageMessageBalloon,
    VideoMessageBalloon,
    LocationMessageBalloon,
    ContactMessageBalloon,
    InfoMessageBalloon,
    AuidoMessageBalloon,
    DateMessageBalloon,
    DocumentMessageBalloon,
    UnansweredCallBalloon
  },
  computed: {
    dem () {
      var messageToReturn = { ...this.message }
      // Reply message decryption
      if (this.message.ReplyMessage) {
        var ReplyMessageObject = JSON.parse(messageToReturn.ReplyMessage)
        if (this.$store.state.ien) {
          if (ReplyMessageObject.MessageType !== 7 && ReplyMessageObject.MessageType !== 99) {
            this.dm(ReplyMessageObject)
          }
        }
        messageToReturn.ReplyMessage = ReplyMessageObject
      } else {
        messageToReturn.ReplyMessage = null
      }

      if (!this.message.isLoaded) {
        // Actual message decryption
        if (this.$store.state.ien) {
          if (messageToReturn.MessageType !== 7 && messageToReturn.MessageType !== 99) {
            this.dm(messageToReturn)
          }
        }
        return messageToReturn
      } else if (messageToReturn.MessageType === 7 || messageToReturn.MessageType === 99) {
        return messageToReturn
      } else {
        var defaultMessage = {}
        defaultMessage.From = messageToReturn.From
        defaultMessage.ConversationID = messageToReturn.ConversationID
        defaultMessage.MessageType = 0
        defaultMessage.Body = ''
        defaultMessage.CreateDate = messageToReturn.CreateDate
        return defaultMessage
      }
    },
    isDeletedMessage () {
      // let messageDate = moment(this.message.UpdateDate)
      // let currentDate = moment()
      // let isVisible = moment.duration(currentDate.diff(messageDate)) < 3600000 // Only showing last hour's deleted messages

      return ((this.message.DeleteStatus === 12 && this.message.From === this.$store.state.session.user.UserID) || this.message.Status === 12)
    },
    isExpiredMessage () {
      let messageDate = moment(this.message.UpdateDate)
      let currentDate = moment()
      let isVisible = moment.duration(currentDate.diff(messageDate)) < 3600000 // Only showing last hour's deleted messages
      return ((this.message.DeleteStatus === 12 && this.message.From === this.$store.state.session.user.UserID) || this.message.Status === 12) && !isVisible
    }
  },
  methods: {
    animateMessage () {

    }
  }
}
</script>

<style scoped>
  .unknownType {
    background-color: greenyellow;
    padding: 20px;
    font-size: 12px;
  }

</style>
